module.exports = __webpack_public_path__ + "img/thumb-002-02.ee37da9c.png";